import React from "react";

export default function ListItem(props) {
  return (
    <button className={`flex items-center gap-x-4 gap-y-3`}>
      <div
        className={`border border-white border-opacity-${props.bor} p-1.5 rounded-fullest`}
      >
        <div
          className={`${props.back} w-12 h-12 rounded-fullest text-themeBlue font-medium text-xl flex 
            justify-center items-center`}
        >
          {props.num}
        </div>
      </div>
      <div className="lg:space-y-2">
        <h1
          className={`font-normal text-xl text-white text-opacity-${props.col} lg:text-start 
            text-center leading-tight`}
        >
          {props.title}
        </h1>
        <p className={`font-light text-sm text-white text-opacity-60 leading-tight lg:${props.descReq} hidden`}>
          {props.desc}
        </p>
      </div>
    </button>
  );
}
